import images from 'assets/images'
import { URL_HOME } from 'helpers/config'
import { Box, Theme, useMediaQuery } from '@mui/material'
import useWindowSize from 'hooks/useWindowSize'

export const MIN_WIDTH_SPINNING_LOGO = 380

const SpinningLogo: React.FC = () => {
  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'))
  const { width } = useWindowSize()

  if (width < MIN_WIDTH_SPINNING_LOGO) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" height="144px">
        <img src={images.LOGO_NN_WHITE} alt="logo" width="210px" />
      </Box>
    )
  }

  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        maxWidth: '90%',
        maxHeight: isMobile ? '80%' : '60%',
        objectFit: 'contain',
      }}>
      <img
        src={images.SPINNING_LOGO}
        alt="logo"
        width="100%"
        height="100%"
        style={{
          ...(isMobile && {
            transform: 'translateY(-10%)',
          }),
        }}
      />
      <a href={URL_HOME}>
        <img
          src={images.LOGO_NN_WHITE}
          style={{
            position: 'absolute',
            bottom: isMobile ? '15px' : '50px',
            left: '50%',
            transform: 'translate(-50%, 0)',
            width: isMobile ? '200px' : '250px',
          }}
        />
      </a>
    </Box>
  )
}

export default SpinningLogo
